import React from "react";

const ProductCardFM = ({ product,buylink }) => {
  if (!product) return null;

  return (
    <div className="mt-2">
      <img
        src={`/${product.image}`}
        alt={product.title}
        className="mx-auto mb-4 rounded-lg"
      />
      <h3 className="text-sm sm:text-base font-semibold text-gray-900 truncate">
        {product.title}
      </h3>
      <div className="mb-1">
        <div className="space-y-1 text-sm font-medium">
          <div className="text-gray-500">
            Price: <span className="line-through">{product.mrp}</span>{" "}
            <span className="text-red-700 text-base">{product.price}</span>
          </div>
        </div>
      </div>
      <a
        href={buylink} target="_blank" rel="noreferrer"
        className="mt-2 inline-block px-4 py-2 w-full bg-black text-white text-xs font-medium rounded hover:bg-gray-800 transition"
      >
        Buy Now
      </a>
    </div>
  );
};

export default ProductCardFM;
